export default __webpack_public_path__ + "static/media/avatar7.1a5bc8cd.png";